// ============================================================================
//  This file now resolves content from the ACTIVE LOCATION.
//  To edit content per location, see: src/config/locations.js
//  Components import the same names as before — no component changes needed.
// ============================================================================
import { getActiveConfig } from "./config/locations";

const cfg = getActiveConfig();

export const BUSINESS = cfg.BUSINESS;
export const ACUITY_URL = cfg.ACUITY_URL;
export const GHL_CALENDAR_URL = cfg.GHL_CALENDAR_URL;
export const GHL_CHAT_WIDGET_ID = cfg.GHL_CHAT_WIDGET_ID;
export const HIDE_PHONE_FIELD = cfg.HIDE_PHONE_FIELD;
export const ACUITY_NOTES_FIELD_ID = cfg.ACUITY_NOTES_FIELD_ID;
export const META_PIXEL_ID = cfg.META_PIXEL_ID;
export const CRM_LEAD_URL = cfg.CRM_LEAD_URL;
export const CRM_SOURCE = cfg.CRM_SOURCE;
export const CRM_SECRET = cfg.CRM_SECRET;
export const LEGAL_NAME = cfg.LEGAL_NAME;
export const PRIVACY_EMAIL = cfg.PRIVACY_EMAIL;
export const NO_DEPOSIT = cfg.NO_DEPOSIT;
export const CONTACT_FIRST = cfg.CONTACT_FIRST;
export const DIRECT_BOOKING = cfg.DIRECT_BOOKING;
export const OFFER = cfg.OFFER;
export const COUNTDOWN_MINUTES = cfg.COUNTDOWN_MINUTES;
export const HERO = cfg.HERO;
export const WHAT_YOU_GET = cfg.WHAT_YOU_GET;
export const BEFORE_AFTER = cfg.BEFORE_AFTER;
export const INTRO_VIDEO = cfg.INTRO_VIDEO;
export const VIDEO_TESTIMONIALS = cfg.VIDEO_TESTIMONIALS;
export const REVIEWS = cfg.REVIEWS;
export const HOW_IT_WORKS = cfg.HOW_IT_WORKS;
export const HOW_IT_WORKS_HEADING = cfg.HOW_IT_WORKS_HEADING;
export const WHO_WE_ARE = cfg.WHO_WE_ARE;
export const TREATMENT_IMAGES = cfg.TREATMENT_IMAGES;
export const OFFER_INCLUDES = cfg.OFFER_INCLUDES;
export const FAQS = cfg.FAQS;
export const QUIZ_STEPS = cfg.QUIZ_STEPS;
export const DISQUALIFY = cfg.DISQUALIFY;
export const DISQUALIFIED_MESSAGE = cfg.DISQUALIFIED_MESSAGE;
